import { generatePath } from "../utilities/RedirectUtils";
import CONSTANTS from "../app-consts/appConstants";

export const determinePPU = (props, service) => {
  const {
    commonBenefits,
    partnerDetails: {
      partnerDetails: { experience },
    }
  } = props;
  let benefitsService = commonBenefits?.services?.filter(
    (services) => services.type === service?.serviceType
  )[0];
  if (
    experience?.serviceBased &&
    benefitsService?.status === CONSTANTS.SERVICE_STATUS_NOT_COVERED &&
    experience?.ppuEnabled
  ) {
    if (benefitsService.payPerUseWhenNotCovered) {
      props.updateBenefitsFlag(false);
    }
    props.updatePpuFlag("Y");
    props.updateLoggedInFlag("N");
    props.updateCCardInfo({ transactionAmount: service.originalCost });
  } else if (props.omniStreamlined && experience?.serviceBased &&
    benefitsService?.status === CONSTANTS.SERVICE_STATUS_COVERED &&
    experience?.ppuEnabled) {
    props.updateBenefitsFlag(true);
    props.updatePpuFlag("N");
    props.updateLoggedInFlag("Y");
    props.clearCCardInfo();
  }
  else if (
    experience?.serviceBased &&
    benefitsService?.status === CONSTANTS.SERVICE_STATUS_NOT_COVERED &&
    !experience?.ppuEnabled
  ) {
    //TODO: We may need if excluded service types cannot be reused
    props.history.push(generatePath("ServiceTransition"));
  }
}
